import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      id: 0,
      productId: 0,
      sku: '',
      name: '',
      foldername: '',
      img: '',
      msrp: 0,
      disabled: false,
      maskHorizontal: '',
      maskVertical: '',
      printData: {
        printMinPpi: 0,
        portrait: [{
          width: 0,
          height: 0,
          rotate: 0,
          sku: '',
          index: 1,
          pdfIndex: 1,
          x: 0,
          y: 0,
          bleed: false,
        }],
        landscape: [{
          width: 0,
          height: 0,
          rotate: 0,
          sku: '',
          index: 1,
          pdfIndex: 1,
          x: 0,
          y: 0,
          bleed: false,
        }],
      },
      preview: {
        portrait: [{
          img: '',
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          angle: 0,
          index: 1,
          z: 0,
          zoomedOverlay: '',
          zoomedX: 0,
          zoomedY: 0,
          zoomedWidth: 0,
          zoomedHeight: 0,
        }],
        landscape: [{
          img: '',
          x: 0,
          y: 0,
          width: 0,
          height: 0,
          angle: 0,
          index: 1,
          z: 0,
          zoomedOverlay: '',
          zoomedX: 0,
          zoomedY: 0,
          zoomedWidth: 0,
          zoomedHeight: 0,
        }],
        numPhotos: 1,
      },
    },
  ],
  item: {
    id: 0,
    productId: 0,
    sku: '',
    name: '',
    foldername: '',
    img: '',
    msrp: 0,
    disabled: false,
    maskHorizontal: '',
    maskVertical: '',
    printData: {
      printMinPpi: 0,
      portrait: [{
        width: 0,
        height: 0,
        rotate: 0,
        sku: '',
        index: 1,
        pdfIndex: 1,
        x: 0,
        y: 0,
        bleed: false,
        textX: 0,
        textY: 0,
        textWidth: 0,
        textHeight: 0,
        fontColor: ""
      }],
      landscape: [{
        width: 0,
        height: 0,
        rotate: 0,
        sku: '',
        index: 1,
        pdfIndex: 1,
        x: 0,
        y: 0,
        bleed: false,
        textX: 0,
        textY: 0,
        textWidth: 0,
        textHeight: 0,
        fontColor: ""
      }],
    },
    preview: {
      portrait: [{
        img: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        angle: 0,
        index: 1,
        z: 0,
        zoomedOverlay: '',
        zoomedX: 0,
        zoomedY: 0,
        zoomedWidth: 0,
        zoomedHeight: 0,
        textX: 0,
        textY: 0,
        textWidth: 0,
        textHeight: 0,
        fontColor: ""
      }],
      landscape: [{
        img: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        angle: 0,
        index: 1,
        z: 0,
        zoomedOverlay: '',
        zoomedX: 0,
        zoomedY: 0,
        zoomedWidth: 0,
        zoomedHeight: 0,
        textX: 0,
        textY: 0,
        textWidth: 0,
        textHeight: 0,
        fontColor: ""
      }],
      numPhotos: 1,
    },
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/items?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function item(state = initialState, action) {
  switch (action.type) {
    case types.ITEMS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.ITEMS_FETCH_ERROR:
    case types.ITEM_FETCH_ERROR:
    case types.ITEM_EDIT_ERROR:
    case types.ITEM_SET_ERROR:
    case types.ITEM_DELETE_ERROR:
    case types.ITEM_DISABLE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.ITEM_FETCH_SUCCESS:
    case types.ITEM_EDIT_SUCCESS:
    case types.ITEM_SET_SUCCESS:
      return assign({}, state, {
        item: action.res,
      });
    case types.ITEM_CATALOGS_FETCH_SUCCESS:
      // TODO: append the list of catalogs to item
      return assign({}, state, {
        item: state.item,
        catalogs: action.res,
      });
    case types.ITEM_DISABLE_SUCCESS:
      return assign({}, state, {
        itemDisabled: action.res.ok,
      });
    case types.ITEM_CATALOGS_FETCH_SUCCESS:
      state.item.catalogs = action.res.data;
      return assign({}, state, state);
    case types.ITEM_DELETE_SUCCESS:
      return assign({}, state, {
        itemDelete: action.res.ok,
      });
    case types.ITEMS_CLEAR_ERRORS:
      return assign({}, state, {
        error: '',
      });
    default:
      return state;
  }
}

export default item;



// WEBPACK FOOTER //
// ./src/reducers/items.js